import { render, staticRenderFns } from "./FleetDashboard.vue?vue&type=template&id=ef6f385c&scoped=true&"
import script from "./FleetDashboard.vue?vue&type=script&lang=js&"
export * from "./FleetDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FleetDashboard.vue?vue&type=style&index=0&id=ef6f385c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6f385c",
  null
  
)

export default component.exports